import Vue from 'vue';
import Vuex from 'vuex';
import device from '@/store/modules/device';
import user from '@/store/modules/user';
import getters from './getters';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    getters: getters,
    mutations: {},
    actions: {},
    modules: {
        device,
        user,
    },
});
